<template>
    <v-card class="pa-4">
        <v-row>
            <v-textarea :disabled="!isEditMode"
                        :visible="!isEditMode"
                        outlined dense
                        auto-grow
                        clearable
                        rows="1"
                        v-model="showInfo.adminNotes"
                        label="Description of changes (optional)" />
            <v-btn class="ml-1 mr-1"
                   color="primary"
                   @click="toggleEditMode">
                {{ isEditMode ? "Save" : "Edit" }}
            </v-btn>
        </v-row>
        <v-row>
            <v-col cols="4">
                <DatepickerFormatted :disabled="!isEditMode"
                                     :date="showInfo.processDate"
                                     label="Process Date" class="mr-1"
                                     v-on:updateDates="updateDates($event, 'processDate')" />
            </v-col>
            <v-col cols="8">&nbsp;</v-col>
        </v-row>

       

        <v-row>
            <p class="text-h6">Receipts &amp; Fees</p>

        </v-row>
        <v-divider class="my-3"></v-divider>
        <v-row>


            <v-col cols="4">
                <v-text-field v-model="showInfo.grossRec"
                              :disabled="!isEditMode"  prefix="$" :rules="[isValidNumber]"
                              label=" Gross Receipts" class="form-text"
                              outlined dense></v-text-field>
            </v-col>



        </v-row>
        <v-row>
            <v-col>

                <v-text-field v-model="showInfo.totalEntries"
                              :disabled="!isEditMode" class="mr-1 form-text"
                              label="Total Entries" :rules="[isValidNumber]"
                              outlined dense>></v-text-field>
            </v-col>
            <v-col>
                <v-text-field v-model="showInfo.fees"
                              :disabled="!isEditMode" class="mr-1 form-text"
                              label="Fees"  prefix="$" :rules="[isValidNumber]"
                              outlined dense></v-text-field>
            </v-col>
            <v-col cols="2">
                <v-btn v-on:click="calculateTotalFees" color="primary" :disabled="!isEditMode">
                    <v-icon> mdi-calculator </v-icon>
                </v-btn>
            </v-col>
            <v-col>
                <v-text-field v-model="showInfo.totalFees"
                              :disabled="!isEditMode"  prefix="$"
                              label=" Total Fees" class="form-text" :rules="[isValidNumber]"
                              outlined dense></v-text-field>
            </v-col>



        </v-row>
        <v-row>
            <p class="text-h6">Payment Information</p>

        </v-row>
        <v-divider class="my-3"></v-divider>
        <v-row>
            <v-col>
                <DatepickerFormatted :disabled="!isEditMode"
                                     :date="showInfo.paymentDate" dense
                                     label="Payment Date" class="mr-1 form-text"
                                     v-on:updateDates="updateDates($event, 'paymentDate')" />
            </v-col>
            <v-col>
                <v-text-field v-model="showInfo.checkNumber"
                              :disabled="!isEditMode" clearable dense
                              label="Payment Note (CC/Check #)" class="mr-1 form-text"
                              :rules="[v => (v || '' ).length <= 10 || 'Limited to 10 chars']"
                              outlined></v-text-field>


            </v-col>
        </v-row>

        <v-row>
            <p class="text-h6">Entries</p>

        </v-row>
        <v-divider class="my-3"></v-divider>

        <v-row class="mt-3">
            <v-col>
                <v-text-field v-model="showInfo.dogEntries"
                              :disabled="!isEditMode" clearable dense
                              label="Dog Entries" class="mr-1 form-text"
                              :rules="[isValidNumber]"
                              outlined></v-text-field>
            </v-col>
            <v-col>
                <v-text-field v-model="showInfo.altDogEntries"
                              :disabled="!isEditMode" clearable dense
                              :rules="[isValidNumber]"
                              label="Alt Dog Entries" class="mr-1 form-text"
                              outlined></v-text-field>
            </v-col>
            <v-col>
                <v-text-field v-model="showInfo.bitchEntries"
                              :disabled="!isEditMode" clearable dense
                              :rules="[isValidNumber]"
                              label="Bitch Entries" class="mr-1 form-text"
                              outlined></v-text-field>
            </v-col>
            <v-col>
                <v-text-field v-model="showInfo.altBitchEntries"
                              :disabled="!isEditMode" clearable dense
                              :rules="[isValidNumber]" type
                              label="Alt Bitch Entries" class="mr-1 form-text"
                              outlined></v-text-field>
            </v-col>


        </v-row>


        <div class="mt-3">

            <v-row class="pt-0 mt-0">
                <v-col>
                    <h3>Notes</h3>
                </v-col>

            </v-row>

            <v-row>
                <v-textarea disabled
                            @input="updateText('notes', $event)"
                            :value="showInfo.notes"
                            outlined dense class="form-text"
                            rows="1"
                            auto-grow></v-textarea>

            </v-row>
        </div>
        <v-snackbar v-model="showInfoMessage" title color="green">
            {{ infoMessage }}
            <template v-slot:action="{ attrs }">
            <v-btn color="primary" text v-bind="attrs" @click="showInfoMessage = false">
                Close
            </v-btn>
            </template>
        </v-snackbar>
        <v-snackbar v-model="showErrorMessage" title color="red">
            {{ errorMessage }}
            <template v-slot:action="{ attrs }">
            <v-btn color="primary" text v-bind="attrs" @click="showErrorMessage = false">
                Close
            </v-btn>
            </template>
        </v-snackbar>
    </v-card>

</template>

<script lang="ts">
import Vue from "vue";
import DatepickerFormatted from "../../../common/inputs/DatepickerFormatted.vue";

import showService from "@/services/admin/showService";

import { UserInfo } from "@/types/User";
import { Messages } from "@/constants";
import { ShowInfo, ShowType, ShowAffiliateInfo, ShowPerson, JudgeScheduleInfo, PointSchedule } from '@/types/admin/Show';

export default Vue.extend({
    name: "ShowProcessing",
    components: {
        DatepickerFormatted,
    },
    data: function () {
        return {
            tab: null,
            showInfo: {
                showId: "",
                clubId: "",
                showType: {} as ShowType,
                showCoordinator: {
                } as ShowPerson, showSecretary: {} as ShowPerson,
                sponsoringAffiliate: {} as ShowAffiliateInfo, judgeSchedules: [] as JudgeScheduleInfo[],
            } as ShowInfo,
            pointSchedules: [] as PointSchedule[],
            pointScheduleIds: [] as any[],
            isEditMode: false,
            isValid:true,
            showValidationDialog: false,
            validationResult: {
                warnings: [],
                errors: []
            } as any,
            reloadPage: false,
            showTypes: [] as ShowType[],
            showTypeDescriptions: [] as string[],
            showTypeIds: [] as string[],
            isLoading: false,
            calculatedValue:"0.00",
            errorMessage: '',
            infoMessage: '',
            showErrorMessage: false,
            showInfoMessage: false
        };
    },
    methods: {
        reloadData: function () {
            if (this.showId) {
                showService
                    .getShowById(this.showId)
                    .then((res) => {
                        this.showInfo = res;
                        this.errorMessage = '';
                        this.showErrorMessage = false;
                    });
            }
        },
        calculateTotalFees: function () {
            if (!this.showInfo) {
                return;
            }
            if (this.showInfo.totalEntries == null) {
                return;
            }
            var feeAmount = Number(this.showInfo.fees);
            this.showInfo.totalFees = (feeAmount * this.showInfo.totalEntries).toFixed(2).toString();
        },
        toggleEditMode: function () {
            if (this.isEditMode) {
                this.saveChanges();
            }

            this.isEditMode = !this.isEditMode;
        },
        saveChanges: function () {
            this.errorMessage = "";
            this.$store.dispatch("changeLoaderStatus", true);
            showService
                .editShowProcessing(this.showInfo)
                .then((res) => {
                    if (res.success) {
                        if (res.id && res.id != this.$props.showId) {
                            this.$router.push({ path: `/admin/shows/${res.id}` }).catch(this.$handleNavigationError);
                        }
                        this.reloadData();
                        this.isEditMode = false; 
                        this.infoMessage = Messages.SaveSuccessful;
                        this.showInfoMessage = true;
                    }
                    else {
                        this.errorMessage = Messages.SaveError + " " + res.messages.join(', ');
                        this.showErrorMessage = true;
                    }
                }).catch(e => {
                    this.errorMessage = Messages.SaveError + " " + "Please enter valid numbers";
                    this.isEditMode = true;
                })
                .finally(() => this.$store.dispatch("changeLoaderStatus", false));
        },
        isValidNumber(value: string) {
            if (!value) {
                return true;
            }
            if (!isNaN(parseFloat(value))) return true;

            return 'Must be valid number';

        },
        updateDates: function (val: any, key: string) { 
            this.$data.showInfo[key] = val?.date;
            this.$data.showInfo = Object.assign({}, this.$data.showInfo);
        },
        updateText: function (key: string, event: string) {
            this.$data.showInfo[key] = event;
        },

        
    },
    created: function () {
        this.reloadData();
    },
    watch: {
        showId: function (newVal: String) {
            this.reloadData();             
        },
        
    },
    props: {
        showId: { type: String },
    },
    computed: {
        userInfo(): UserInfo {
            return this.$store.state.userInfo;
        },
        
    },
});
</script>
